import React, { useState } from 'react';

const API_BASE_URL = 'http://localhost:3000';

const CATEGORIAS = [
  { value: 'agricultor', label: 'Agricultor', tipo: 'agricultor' },
  { value: 'sacolao', label: 'Vendedor (Sacolão, Hortifruit)', tipo: 'agricultor' },
  { value: 'restaurante', label: 'Restaurante', tipo: 'restaurante' },
  { value: 'escola', label: 'Escola', tipo: 'restaurante' },
  { value: 'faculdade', label: 'Faculdade', tipo: 'restaurante' },
  { value: 'outro', label: 'Outro negócio (comprador)', tipo: 'restaurante' },
];

const CadastroPage = ({ onNavigate }) => {
  const [formData, setFormData] = useState({
    categoria: '',
    nome: '',
    cnpj: '',
    telefone: '',
    email: '',
    senha: '',
    confirmarSenha: '',
    cep: '',
    logradouro: '',     
    bairro: '',
    cidade: '',   
    estado: '', 
    numero: '',
    complemento: '',
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loadingCep, setLoadingCep] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({ ...prev, [id]: value }));
    setError('');
  };

  const handleCepChange = async (e) => {
    const cep = e.target.value.replace(/\D/g, '');
    
    setFormData(prev => ({ ...prev, cep: cep }));

    if (cep.length === 8) {
      setLoadingCep(true);
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
        const data = await response.json();

        if (!data.erro) {
          setFormData(prev => ({
            ...prev,
            logradouro: data.logradouro || '',
            bairro: data.bairro || '',
            cidade: data.localidade || '',
            estado: data.uf || '',
          }));
        } else {
          setError('CEP não encontrado. Preencha os campos manualmente.');
        }
      } catch (error) {
        console.error("Erro ao buscar CEP:", error);
        setError('Erro ao buscar CEP. Verifique sua conexão.');
      } finally {
        setLoadingCep(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    
    // Validações
    if (formData.senha !== formData.confirmarSenha) {
      setError('As senhas não coincidem!');
      return;
    }

    if (formData.senha.length < 6) {
      setError('A senha deve ter pelo menos 6 caracteres.');
      return;
    }

    if (formData.cnpj.replace(/\D/g, '').length !== 14) {
      setError('CNPJ deve ter 14 dígitos.');
      return;
    }

    setLoading(true);

    try {
      // Determinar tipo de usuário baseado na categoria
      const categoriaSelecionada = CATEGORIAS.find(c => c.value === formData.categoria);
      const tipoUsuario = categoriaSelecionada.tipo;
      const endpoint = tipoUsuario === 'agricultor' ? '/agricultores' : '/restaurantes';

      // Preparar dados para envio
      const dadosUsuario = {
        nome: formData.nome,
        email: formData.email,
        senha: formData.senha,
        cnpj: formData.cnpj.replace(/\D/g, ''),
        telefone: formData.telefone.replace(/\D/g, ''),
        cep: formData.cep.replace(/\D/g, ''),
        logradouro: formData.logradouro,
        numero: formData.numero,
        complemento: formData.complemento,
        bairro: formData.bairro,
        cidade: formData.cidade,
        estado: formData.estado,
      };

      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dadosUsuario),
      });

      const data = await response.json();

      if (response.ok) {
        const tipoLabel = tipoUsuario === 'agricultor' ? 'Agricultor' : 'Restaurante';
        setSuccess(`${tipoLabel} cadastrado com sucesso! Redirecionando para login...`);
        
        // Limpar formulário
        setFormData({
          categoria: '',
          nome: '',
          cnpj: '',
          telefone: '',
          email: '',
          senha: '',
          confirmarSenha: '',
          cep: '',
          logradouro: '',
          bairro: '',
          cidade: '',
          estado: '',
          numero: '',
          complemento: '',
        });

        // Redirecionar após 2 segundos
        setTimeout(() => {
          onNavigate('Login');
        }, 2000);
      } else {
        setError(data.error || 'Erro ao cadastrar. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro na requisição:', error);
      setError('Erro de conexão com o servidor. Verifique se o backend está rodando.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container-split">
      <div className="split-left">
        <div className="brand-content">
          <div className="floating-icon">🌱</div>
          <h1>Conecte seu negócio</h1>
          <p>Faça parte da maior rede de conexão entre produtores e compradores.</p>
          <div className="features">
            <div className="feature-item">✓ Gestão completa</div>
            <div className="feature-item">✓ Conexão direta</div>
            <div className="feature-item">✓ Crescimento sustentável</div>
          </div>
        </div>
      </div>

      <div className="split-right">
        <div className="form-box">
          <h2 className="page-title">
            CRIAR CONTA
          </h2>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          {success && (
            <div className="success-message">
              {success}
            </div>
          )}
          
          <form onSubmit={handleSubmit}>
            
            <div className="form-group">
              <label htmlFor="categoria">Tipo de Negócio *</label>
              <select 
                id="categoria" 
                value={formData.categoria} 
                onChange={handleChange} 
                required 
                disabled={loading}
              >
                <option value="">Selecione sua categoria</option>
                {CATEGORIAS.map(cat => (
                  <option key={cat.value} value={cat.value}>{cat.label}</option>
                ))}
              </select>
            </div>
            
            <div className="form-group">
              <label htmlFor="nome">Nome do Negócio *</label>
              <input 
                type="text" 
                id="nome" 
                placeholder="Ex: Fazenda São José"
                value={formData.nome} 
                onChange={handleChange} 
                required 
                disabled={loading}
              />
            </div>
            
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="cnpj">CNPJ *</label>
                <input 
                  type="text" 
                  id="cnpj" 
                  placeholder="00.000.000/0000-00"
                  value={formData.cnpj} 
                  onChange={handleChange} 
                  required 
                  disabled={loading}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="telefone">Telefone *</label>
                <input 
                  type="tel" 
                  id="telefone" 
                  placeholder="(85) 99999-9999"
                  value={formData.telefone} 
                  onChange={handleChange} 
                  required 
                  disabled={loading}
                />
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="cep">CEP *</label>
              <input 
                type="text" 
                id="cep" 
                placeholder="60000-000"
                value={formData.cep} 
                onChange={handleCepChange}
                maxLength="8"
                required 
                disabled={loading || loadingCep}
              />
              {loadingCep && <small style={{color: '#797129'}}>Buscando CEP...</small>}
            </div>

            <div className="form-group">
              <label htmlFor="logradouro">Logradouro *</label>
              <input 
                type="text" 
                id="logradouro" 
                placeholder="Rua, Avenida, etc."
                value={formData.logradouro} 
                onChange={handleChange} 
                required 
                disabled={loading}
              />
            </div>

            <div className="form-row">
              <div className="form-group" style={{flex: '0 0 30%'}}>
                <label htmlFor="numero">Número *</label>
                <input 
                  type="text" 
                  id="numero" 
                  placeholder="123"
                  value={formData.numero} 
                  onChange={handleChange} 
                  required 
                  disabled={loading}
                />
              </div>
              <div className="form-group">
                <label htmlFor="complemento">Complemento</label>
                <input 
                  type="text" 
                  id="complemento" 
                  placeholder="Apto, Sala, etc."
                  value={formData.complemento} 
                  onChange={handleChange} 
                  disabled={loading}
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="bairro">Bairro *</label>
              <input 
                type="text" 
                id="bairro" 
                placeholder="Nome do bairro"
                value={formData.bairro} 
                onChange={handleChange} 
                required 
                disabled={loading}
              />
            </div>

            <div className="form-row">
              <div className="form-group" style={{flex: '2'}}>
                <label htmlFor="cidade">Cidade *</label>
                <input 
                  type="text" 
                  id="cidade" 
                  placeholder="Nome da cidade"
                  value={formData.cidade} 
                  onChange={handleChange} 
                  required 
                  disabled={loading}
                />
              </div>
              <div className="form-group" style={{flex: '0 0 100px'}}>
                <label htmlFor="estado">UF *</label>
                <input 
                  type="text" 
                  id="estado" 
                  placeholder="CE"
                  value={formData.estado} 
                  onChange={handleChange} 
                  maxLength="2" 
                  required 
                  disabled={loading}
                />
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input 
                type="email" 
                id="email" 
                placeholder="contato@seunegocio.com"
                value={formData.email} 
                onChange={handleChange} 
                required 
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="senha">Senha *</label>
              <div className="input-with-icon">
                <input 
                  type={showPassword ? "text" : "password"}
                  id="senha" 
                  placeholder="Mínimo 6 caracteres"
                  value={formData.senha} 
                  onChange={handleChange} 
                  required 
                  disabled={loading}
                />
                <button 
                  type="button" 
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>
            
            <div className="form-group">
              <label htmlFor="confirmarSenha">Confirmar Senha *</label>
              <div className="input-with-icon">
                <input 
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmarSenha" 
                  placeholder="Digite a senha novamente"
                  value={formData.confirmarSenha} 
                  onChange={handleChange} 
                  required 
                  disabled={loading}
                />
                <button 
                  type="button" 
                  className="toggle-password"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  disabled={loading}
                >
                  {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>
            
            <button type="submit" className="form-button" disabled={loading}>
              {loading ? 'Cadastrando...' : 'Criar minha conta'}
            </button>
          </form>
          
          <div className="link-cadastro">
            Já tem uma conta? <span onClick={() => !loading && onNavigate('Login')}>Faça login</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CadastroPage;
